export { calendarDays, deliveryDay, loadBarkInterval } from '@wordpuppi/shared';
const monday = (date: Date) => (date.getDay() + 6) % 7; // ISO 8601 counts Monday as day 0.
/** AB#841: ISO-8601 week number by the Thursday rule — the week belongs to the year holding its Thursday. */
export function isoWeek(date: Date): number {
  const thursday = new Date(date.getFullYear(), date.getMonth(), date.getDate() - monday(date) + 3);
  const first = new Date(thursday.getFullYear(), 0, 4);
  first.setDate(first.getDate() - monday(first) + 3);
  // ponytail: rounding absorbs the DST hour these local midnights can differ by; no week-year, the gutter shows none.
  return 1 + Math.round((thursday.getTime() - first.getTime()) / 604800000);
}
